<template>
    <div class="dz_air_control">
        <div class="left_menu">
            <me-tree
                ref="myTree"
                :treeData="treeData"
                :defaultProps="defaultProps"
                :nodeKey="'point_id'"
                :treeLoading="treeLoading"
                :treeToolBar="false"
                :defaultExpandedKeys="defaultExpandedKeys"
                :showCheckbox="true"
                :cascadingVar="false"
                :checkStrictly.sync="checkStrictly"
                :isCheckClick="true"
                :show-icon="false"
                :showStretch="false"
                @handleCheckBoxClick="handleTreeNodeClick"
            ></me-tree>
        </div>
        <div class="middle_table">
            <el-form :inline="true" class="leader-style-form" :model="queryForm" style="margin-left: 20px">
<!--                <el-form-item label="名称" prop="point_name">-->
<!--                    <el-input placeholder="请输入名称" v-model="queryForm.point_name"/>-->
<!--                </el-form-item>-->
                <el-form-item>
<!--                    <el-button size="medium" @click="getAir">搜索</el-button>-->
<!--                    <el-button size="medium" @click="queryReset">重置</el-button>-->
                    <el-button size="medium" @click="strategy">策略</el-button>
                </el-form-item>
            </el-form>
            <el-table ref="multipleTable" row-key="point_id" :data="tableData" tooltip-effect="dark" height="100%" style="width: 100%;position: absolute;"  border class="leader-style-table"  highlight-current-row fit>
<!--                <el-table-column type="selection" width="55"></el-table-column>-->
                <el-table-column label="名称" show-overflow-tooltip>
                    <template slot-scope="scope">{{ scope.row.point_name }}</template>
                </el-table-column>
                <el-table-column prop="status" label="状态" width="120"></el-table-column>
                <el-table-column prop="mode" label="模式" width="120"></el-table-column>
                <el-table-column prop="wind_speed" label="风速" width="120"></el-table-column>
                <el-table-column prop="set_temp" label="设定温度" width="120"></el-table-column>
                <el-table-column prop="wind_temp" label="回风温度" width="120"></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button type="text" class="button-custom" @click="strategy">策略</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="air_cnt">
            <div class="air_title">控制面板</div>
            <div class="air_buttons">
                <el-form
                    label-width="120px"
                    :model="addForm"
                    :rules="addRules"
                    ref="addForm"
                    class="leader-style-form leader-radio"
                >
                    <el-form-item
                        label="开/关"
                        style="text-align: left"
                        prop="onoff"
                    >
                        <el-radio-group v-model="addForm.onoff" @change="doOnOffChange">
                            <el-radio label="1">开启</el-radio>
                            <el-radio label="0">关闭</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item
                        label="模式"
                        style="text-align: left"
                        prop="mode"
                    >
                        <el-radio-group v-model="addForm.mode" :disabled="isDisabled">
                            <el-radio label="0">制冷</el-radio>
                            <el-radio label="1">制热</el-radio>
                            <el-radio label="2">除湿</el-radio>
                            <el-radio label="3">通风</el-radio>
                            <el-radio label="4">自动加热</el-radio>
                            <el-radio label="5">自动制冷</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item
                        label="风速"
                        style="text-align: left"
                        prop="speed"
                    >
                        <el-radio-group v-model="addForm.speed" :disabled="isDisabled">
                            <el-radio label="0">停止</el-radio>
                            <el-radio label="1">自动</el-radio>
                            <el-radio label="2">高速</el-radio>
                            <el-radio label="3">中速</el-radio>
                            <el-radio label="4">低速</el-radio>
                            <el-radio label="5">超低速</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item
                        label="温度"
                        style="text-align: left"
                        prop="temp"
                    >
                        <el-input-number v-model="addForm.temp" controls-position="right" @change="handleChange" :min="0" :max="35" :disabled="isDisabled"></el-input-number>
                        <span style="color: #fff;width: 3rem;height: 1rem;font-size: 0.8rem;margin-left: 0.5rem;">°C</span>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="air_cnt_footer">
                <el-button class="leader-common-button"  @click="doSubmit">提 交</el-button>
            </div>
        </div>
        <el-dialog title="设置策略" class="leader-dialog" :visible.sync="open" width="600px">
            <el-form label-width="100px">
                <el-form-item label="开始时间">
                    <el-time-select v-model="start_time"/>
                </el-form-item>
                <el-form-item label="结束时间">
                    <el-time-select v-model="end_time"/>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button class="leader-common-button" @click="open = false">取 消</el-button>
                <el-button class="leader-common-button" @click="open = false">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import * as api from "@/http/Use_electricity_monitor"
import utils from '@/utils/utils'
import Tree from "@/comon/components/tree.vue";
export default {
    components: { "me-tree": Tree },
    data() {
        return {
            isDisabled: false,
            queryForm: {
                point_name: ''
            },
            addForm: {
                onoff: "",
                mode: "",
                speed: "",
                temp: 26,
            },
            start_time: '',
            end_time: '',
            tableData: [],
            multipleSelection: [],
            open: false,
            treeData: [],
            defaultProps: {
                children: "childList",
                label: "point_name",
                disabled: 'status1111'
            },
            treeLoading: false,
            treeToolBar: false,
            defaultCheckKeys: [],
            defaultExpandedKeys: [],
            checkStrictly: false,
            
        };
    },
    mounted() {
        //this.getAir();
        this.getTreeAir();
    },
    methods: {
        getAir() {
          // api.getList({point_name: this.queryForm.point_name}).then(res => {
          //     if(res.error_code === '0') {
          //         this.tableData = res.bus_json
          //         //this.tableData = utils.handleTree(res.bus_json,'point_id','p_point_id')
          //     }
          // })  
        },
        getTreeAir() {
            api.getCommonPointList({ point_class_id: '1750386093968269312' }).then(res => {
                if (res && res.error_code === "0") {
                    this.treeData = res.bus_json;
                    if (res.bus_json && res.bus_json.length) {
                        let defaultPoint =
                            res.bus_json[0].childList &&
                            res.bus_json[0].childList.length
                                ? res.bus_json[0].childList[0]
                                : res.bus_json[0];
                        this.defaultCheckKeys = this.defaultExpandedKeys = [
                            defaultPoint.point_id
                        ];
                        // this.$nextTick(() => {
                        //     this.$refs.myTree.$refs.tree.setCurrentKey(
                        //         defaultPoint.point_id
                        //     );
                        //     this.$refs.myTree.handleNodeClick(defaultPoint);
                        // });
                    }
                }
            });
        },
        handleTreeNodeClick(sth) {
            let c_nodes = this.$refs.myTree.$refs.tree.getCheckedNodes();

            this.tableData = []
            
            for (let d of c_nodes) {
                d['status'] = '开启';
                d['mode'] = '制冷';
                d['wind_speed'] = '自动';
                d['set_temp'] = '25℃';
                d['wind_temp'] = '25℃';
                d.disabled = false
                this.tableData.push(d);
            }
            
        },
        handleTabClick(tab) {
            
        },
        queryReset() {
          this.queryForm.point_name = ''  
        },
        strategy() {
          this.open = true  
        },
        doOnOffChange(val) {
            console.log(11111, val)
            if(val == 0) {
                this.isDisabled = true;
            } else {
                this.isDisabled = false;
            }
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        }
    },
    computed: {
        
    }
};
</script>
<style lang="scss">
.dz_air_control {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding: 0 40px;
    display: flex;
    justify-content: space-between;
    .el-radio {
        color: #fff;
    }
    .el-radio__label {
        font-size: 0.85rem;
    }
    .el-input-number__increase {
        line-height: px2Rem(20px) !important;
    }
    .el-input-number__decrease {
        line-height: px2Rem(20px) !important;
    }
    .el-input-number {
        line-height: px2Rem(40px);
    }
    .el-radio__inner {
        width: 1rem;
        height: 1rem;
    }
    .leader-style-form .el-form-item {
        margin-bottom: 1rem !important;
    }
    .el-form-item__label {
        text-align: center;
    }
    .el-checkbox__inner {
        z-index: 0;
    }
    .left_menu {
        flex: 1;
        height: 90%;
    }
    .middle_table {
        flex: 3;
        height: 90%;
        position:relative;
    }
    .air_cnt {
        flex: 3;
        height: 90%;
        //border: 1px solid #366a7f;
        position: relative;
        .air_title {
            height: 3rem;
            line-height: 3rem;
            width: 100%;
            color: #fff;
            text-align: center;
            font-size: 1rem;
        }
        .air_buttons {
            width: 100%;
            height: calc(100% - 6rem);
            overflow-y: auto;
          //  border: 1px solid red;
        }
        .air_cnt_footer {
            position: absolute;
            bottom: 0;
            height: 3rem;
            width: 100%;
            text-align: center;
        }
    }
}
</style>
